import dayjs from "dayjs";
import * as Yup from "yup";

export const orgvalidationSchema = Yup.object().shape({
  organizationName: Yup.string().required("Name of organization is required"),
  // city: Yup.string().required("City of university is required"),
  // address: Yup.string().required("Organization address is required"),
  // startContractDate: Yup.string().required(
  //   "Start Contract date for organization is required"
  // ),
  // endContractDate: Yup.string().required(
  //   "End Contract date for organization is required"
  // ),
  // address: Yup.string().required("Organisation Address is required."),
  // documents: Yup.array().required("Document for university is required"),
  reminders: Yup.array().of(
    Yup.object({
      isNew: Yup.boolean(), // Flag to determine if it's a new entry
      reminderDateTime: Yup.date()
        .transform((value, originalValue) => {
          // Convert empty strings to null
          console.log(value, originalValue);
          return originalValue === "Invalid Date" ? null : value;
        })
        .nullable("Reminder date time cannot be null")
        // .required("Reminder date and time cannot be empty")
        // .required("Reminder date is required")
        .when("isNew", {
          is: true, // Only validate if it's a new entry
          then: (schema) =>
            schema.test(
              "is-greater",
              "Reminder date time cannot be empty and date time must be after the current date time",
              function (value) {
                console.log(this.parent);
                if (this.parent?.text) {
                  return dayjs(value).isAfter(dayjs(), "millisecond");
                }
                return true;
              }
            ),
          otherwise: (schema) => schema.notRequired(),
        }),
      resendDateTime: Yup.date()
        .transform((value, originalValue) => {
          // Convert empty strings to null
          console.log(value, originalValue);
          return originalValue === "Invalid Date" ? null : value;
        })
        // .required("Resend date is required")
        .nullable()
        .when("isNew", {
          is: true,
          then: (schema) =>
            schema.test(
              "is-greater",
              "Resend date must be after the reminder date",
              function (value) {
                const { reminderDateTime } = this.parent;

                const reminderDate =
                  dayjs(reminderDateTime).format("YYYY-MM-DD");
                const resendDate = dayjs(value).format("YYYY-MM-DD");
                if (this.parent?.text) {
                  // Check if the resend date is after the reminder date
                  if (resendDate > reminderDate) {
                    return true;
                  }

                  // If the dates are the same, check if the resend time is after the reminder time
                  if (resendDate === reminderDate) {
                    const reminderTime =
                      dayjs(reminderDateTime).format("HH:MM");
                    const resendTime = dayjs(value).format("HH:MM");
                    //(reminderTime, resendTime);
                    return resendTime > reminderTime;
                  }
                }

                return true;
              }
            ),
          otherwise: (schema) => schema.notRequired(),
        }),
      text: Yup.string()
        // .required("Resend date is required")/
        .when("isNew", {
          is: true,
          then: (schema) =>
            schema.test(
              "is-greater",
              "Reminder Note is required!",
              function (value) {
                const { reminderDateTime } = this.parent;

                if (reminderDateTime) {
                  return !!value;
                }
                return true;
              }
            ),
          otherwise: (schema) => schema.notRequired(),
        }),
    })
  ),
  owners: Yup.array().of(
    Yup.object().shape({
      ownerName: Yup.string().required("Name of owner person is required"),
      // The email-exists API check runs only on organization creation
      // (in handleFormSubmit), not on every keystroke/validation run
      email: Yup.string()
        .strict()
        .email("Invalid email format")
        .required("Email of owner person is required"),
      phone: Yup.string()
        // .matches(/^\d{12}$/, "Phone number must be proper")
        .required("Phone number of owner person is required"),
    })
  ),
});

/**
 * One commission / programs row. Every field is required except the two Terms
 * & Conditions fields, so an incomplete entry cannot be saved and later break
 * organization creation.
 */
const commissionRowSchema = Yup.object().shape({
  degree: Yup.string().required("Degree is required!"),
  program: Yup.array()
    .min(1, "At least one program is required!")
    .required("Program is required!"),
  commissionType: Yup.string().required("Commission Type is required!"),
  duration: Yup.string().required("Duration is required!"),
  paymentCycle: Yup.string().required("Payment Cycle is required!"),
  // Value applies to Fixed / Percentage; Scholarship is 0 and Custom uses the
  // per-cycle custom values instead
  value: Yup.string().when("commissionType", {
    is: (type) => type === "F" || type === "P",
    then: (schema) => schema.required("Value is required!"),
    otherwise: (schema) => schema.notRequired(),
  }),
  customValue: Yup.array().when("commissionType", {
    is: "C",
    then: (schema) =>
      schema
        .of(Yup.string().nullable().required("Custom value is required!"))
        .test(
          "custom-values-count",
          "All custom values are required!",
          function (value) {
            const cycles = Number(this.parent.paymentCycle) || 0;
            if (cycles <= 0) return true;
            return (value?.length || 0) >= cycles;
          }
        ),
    otherwise: (schema) => schema.notRequired(),
  }),
});

/** True while the user has not started filling a commission row in at all. */
const isBlankCommissionRow = (row = {}) =>
  !row.degree &&
  !(row.program || []).length &&
  !row.commissionType &&
  !row.value &&
  !row.duration &&
  !row.paymentCycle &&
  !(row.customValue || []).length;

/**
 * @param {object}  options
 * @param {boolean} options.isEdit Commissions & programs are only mandatory
 *   when editing an existing university. The create form starts with one blank
 *   commission row, and requiring it made "Save University" fail with no
 *   request and no visible error. A row the user *did* start filling is still
 *   validated on create, so half-entered commissions still cannot be saved.
 */
export const buildUniversityValidationSchema = ({ isEdit = false } = {}) =>
  Yup.object().shape({
  name: Yup.string().required("Name of university is required"),
  country: Yup.string().required("Country of university is required"),
  state: Yup.string().required("State of university is required"),
  contractType: Yup.string().required("Contract Type is required"),
  currency: Yup.string().required("Currency is required"),
  promotedPrograms: Yup.array()
  .min(1, "Select at least one promoted program")
  .required("Promoted Programs is required"),

  // city: Yup.string().required("City of university is required"),
  
  // address: Yup.string().required("Campus address is required"),
  // websiteLink: Yup.string().required("Website Link of university is required"),
  // contractExpireDate: Yup.string().required("Contract Expire date is required"),
  // documents: Yup.array().required("Document for university is required"),

  // commissionsAndPrograms: Yup.array().of(
  //   Yup.object().shape({
  //     degree: Yup.string().required(
  //       "You must select Degree for commissions program!"
  //     ),
  //     program: Yup.array().required("Program for commission prog is required"),
  //     commissionType: Yup.string().required(
  //       "Commission Type for commision and program is required"
  //     ),
  //     // designation: Yup.string().required(
  //     //   "Designation of contact person is required"
  //     // ),
  //     duration: Yup.string().when("commissionType", {
  //       is: "F",
  //       then: (schema) => schema.required("Duration is required!"),
  //       otherwise: (schema) => schema.notRequired(),
  //     }),
  //     paymentCycle: Yup.string().when("commissionType", {
  //       is: "F",
  //       then: (schema) => schema.required("Payment Cycle is required!"),
  //       otherwise: (schema) => schema.notRequired(),
  //     }),
  //   })
  // ),

  // Required when editing, optional while creating - see the factory's docblock.
  commissionsAndPrograms: Yup.array().of(
    Yup.lazy((row) =>
      !isEdit && isBlankCommissionRow(row)
        ? Yup.mixed().notRequired()
        : commissionRowSchema
    )
  ),

  // reminders: Yup.array().of(
  //   Yup.object({
  //     isNew: Yup.boolean(), // Flag to determine if it's a new entry
  //     reminderDateTime: Yup.date()
  //       .transform((value, originalValue) => {
  //         // Convert empty strings to null
  //         console.log(value, originalValue);
  //         return originalValue === "Invalid Date" ? null : value;
  //       })
  //       .nullable("Reminder date time cannot be null")
  //       // .required("Reminder date and time cannot be empty")
  //       // .required("Reminder date is required")
  //       .when("isNew", {
  //         is: true, // Only validate if it's a new entry
  //         then: (schema) =>
  //           schema.test(
  //             "is-greater",
  //             "Reminder date time cannot be empty and date time must be after the current date time",
  //             function (value) {
  //               console.log(this.parent);
  //               if (this.parent?.text) {
  //                 return dayjs(value).isAfter(dayjs(), "millisecond");
  //               }
  //               return true;
  //             }
  //           ),
  //         otherwise: (schema) => schema.notRequired(),
  //       }),
  //     resendDateTime: Yup.date()
  //       .transform((value, originalValue) => {
  //         // Convert empty strings to null
  //         console.log(value, originalValue);
  //         return originalValue === "Invalid Date" ? null : value;
  //       })
  //       // .required("Resend date is required")
  //       .nullable()
  //       .when("isNew", {
  //         is: true,
  //         then: (schema) =>
  //           schema.test(
  //             "is-greater",
  //             "Resend date must be after the reminder date",
  //             function (value) {
  //               const { reminderDateTime } = this.parent;

  //               const reminderDate =
  //                 dayjs(reminderDateTime).format("YYYY-MM-DD");
  //               const resendDate = dayjs(value).format("YYYY-MM-DD");
  //               if (this.parent?.text) {
  //                 // Check if the resend date is after the reminder date
  //                 if (resendDate > reminderDate) {
  //                   return true;
  //                 }

  //                 // If the dates are the same, check if the resend time is after the reminder time
  //                 if (resendDate === reminderDate) {
  //                   const reminderTime =
  //                     dayjs(reminderDateTime).format("HH:MM");
  //                   const resendTime = dayjs(value).format("HH:MM");
  //                   //(reminderTime, resendTime);
  //                   return resendTime > reminderTime;
  //                 }
  //               }

  //               return true;
  //             }
  //           ),
  //         otherwise: (schema) => schema.notRequired(),
  //       }),
  //     text: Yup.string()
  //       // .required("Resend date is required")
  //       .when("isNew", {
  //         is: true,
  //         then: (schema) =>
  //           schema.test(
  //             "check for reminder date time",
  //             "Reminder Note is required!",
  //             function (value) {
  //               const { reminderDateTime } = this.parent;

  //               if (reminderDateTime) {
  //                 return !!value;
  //               }
  //               return true;
  //             }
  //           ),
  //         otherwise: (schema) => schema.notRequired(),
  //       }),
  //   })
  // ),
  });

/**
 * Kept for any caller that does not care about create vs edit. Same rules as
 * the create form.
 */
export const universityvalidationSchema = buildUniversityValidationSchema();

export const agentvalidationSchema = Yup.object({
  firstName: Yup.string().required("Name of agent is required"),
  email: Yup.string()
    .strict()
    .email("Please enter the valid email")
    .required("Email of agent is required"),
  // phone: Yup.string().required("Phone Number of agent is required"),
  // branch: Yup.string().required("Branch of agent is required"),

  branch: Yup.string()
    .required("Branch of agent is required")
    .test(
      "organization-selected",
      "First select an organization",
      function (value) {
        //(this.parent);
        const { organization } = this.parent;
        if (!organization) {
          return false;
        }
        return true;
      }
    ),
  organization: Yup.string().required("Organization is required"),
  roles: Yup.string().required("Roles is required"),
});

export const DefaultIntakeValidationSchema = Yup.object().shape({
  intake: Yup.string().required("Intake is required!"),
  intakeyear: Yup.string().required("Intake Year is required!"),
});
